import React from 'react';

export const StarIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.2341 0L22.4983 15.97L38.4683 19.2341L22.4983 22.4983L19.2341 38.4683L15.97 22.4983L0 19.2341L15.97 15.97L19.2341 0Z"
        fill="white"
      />
    </svg>
  );
};
